import React, { useState } from "react";
import PhoneInput from "react-phone-number-input";
import styled, { useTheme } from "styled-components";
import "../../Assets/styles/customPhoneSelect.css";
import "react-phone-number-input/style.css";
import { ReactComponent as MicrosoftLogo } from "../../Assets/icons/logo/microsoftLogo.svg";
import { ReactComponent as GoogleLogo } from "../../Assets/icons/logo/google.svg";
import { ReactComponent as AppleLogo } from "../../Assets/icons/logo/apple-logo.svg";
import { ReactComponent as NextArrow } from "../../Assets/iconsv2/generic/nextArrow.svg";
import { ReactComponent as Check } from "../../Assets/iconsv2/generic/check.svg";
import { ReactComponent as CheckEmpty } from "../../Assets/iconsv2/generic/checkEmpty.svg";
import { useTranslate } from '@tolgee/react';
import { useSearchParams } from "react-router-dom";
import PrimaryButton from "../GenericComponents/PrimaryButton";
import LoginButton from "../GenericComponents/LoginButton";
import {
  BUSINESS_ACCOUNT,
  PERSONAL_ACCOUNT,
} from "../../Constants/constantValues";

const EnterPhoneNumber = ({
  phone,
  setPhone,
  setCountryCode,
  onSigninSubmit,
  defaultCountry,
  onLoginMicrosoftSubmit,
  onLoginGoogleSubmit,
  onLoginAppleSubmit,
}) => {
  const navigateInNewTab = (to) => {
    // let url = window.location.origin
    // window.open(`${url}/${to}`)
    window.open("https://www.emotii.ai/terms");
  };

  const [searchParams] = useSearchParams();
  const [accountType, setAccountType] = useState(PERSONAL_ACCOUNT);
  const theme = useTheme();
  const { t } = useTranslate();
  return (
    <Container>
      <LeftSide>
        <Card>
          <Group>
            <Group style={{ gap: "40px", alignItems: "center" }}>
              <h1>{t('login.authenticate')}</h1>
              {!searchParams.get("desktop_login") &&
                (accountType === PERSONAL_ACCOUNT ? (
                  <InfoText>
                    {t('login.auth_using_peronal_account')}
                  </InfoText>
                ) : (
                  <InfoText>
                    {t('login.auth_using_business_account')}
                    <span
                      onClick={() =>
                        window.open(
                          "https://platform.emotii.ai/login",
                          "_blank"
                        )
                      }
                    >
                      platform.emotii.ai
                    </span>
                  </InfoText>
                ))}
            </Group>
            {!searchParams.get("desktop_login") && (
              <BusinessToggleWrapper>
                <ToggleButton
                  onClick={() => setAccountType(PERSONAL_ACCOUNT)}
                  selected={accountType === PERSONAL_ACCOUNT}
                >
                  {accountType === PERSONAL_ACCOUNT ? (
                    <CheckWrapper>
                      <Check />
                    </CheckWrapper>
                  ) : (
                    <CheckEmptyWrapper>
                      <CheckEmpty />
                    </CheckEmptyWrapper>
                  )}
                  {t('login.personal_account')}
                </ToggleButton>
                <ToggleButton
                  onClick={() => setAccountType(BUSINESS_ACCOUNT)}
                  selected={accountType === BUSINESS_ACCOUNT}
                >
                  {accountType === BUSINESS_ACCOUNT ? (
                    <CheckWrapper>
                      <Check />
                    </CheckWrapper>
                  ) : (
                    <CheckEmptyWrapper>
                      <CheckEmpty />
                    </CheckEmptyWrapper>
                  )}
                  {t('login.business_account')}
                </ToggleButton>
              </BusinessToggleWrapper>
            )}
            {accountType === PERSONAL_ACCOUNT && (
              <Line>
                <CustomPhoneWrapper>
                  <PhoneInput
                    international
                    defaultCountry={defaultCountry}
                    name="phoneNumber"
                    placeholder={t('profile.phone_number')}
                    value={phone}
                    onChange={(e) => setPhone(e)}
                    onCountryChange={(e) => setCountryCode(e)}
                    limitMaxLength
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && phone && phone.length >= 8) {
                        onSigninSubmit(e);
                      }
                    }}
                  />
                </CustomPhoneWrapper>
                <PrimaryButton
                  style={{ padding: "14px 13px", borderRadius: "10px" }}
                  disabled={!phone || phone?.length < 8}
                  id="sign-in-button"
                  iconLeft={<NextArrow />}
                  onClick={(e) => onSigninSubmit(e)}
                />
              </Line>
            )}
            {!searchParams.get("desktop_login") && (
              <LoginButtonsWrapper>
                {accountType === PERSONAL_ACCOUNT && (
                  <Line
                    style={{ justifyContent: "center", marginBottom: "20px" }}
                  >
                    <InfoText>{t('login.continue_with')}</InfoText>
                  </Line>
                )}

                <LoginButton
                  iconLeft={<GoogleLogo />}
                  id="sign-in-sso-google"
                  onClick={(e) => onLoginGoogleSubmit(e)}
                  text={t('login.continue_with_google')}
                />

                <LoginButton
                  iconLeft={<MicrosoftLogo />}
                  id="sign-in-sso"
                  onClick={(e) => onLoginMicrosoftSubmit(e)}
                  text={t('login.continue_with_microsoft')}
                />

                <LoginButton
                  iconLeft={<AppleLogo />}
                  id="sign-in-sso-apple"
                  onClick={(e) => onLoginAppleSubmit(e)}
                  text={t('login.continue_with_apple')}
                />
              </LoginButtonsWrapper>
            )}

            <TermsInfo onClick={() => navigateInNewTab("terms-and-conditions")}>
              <p>
                {t('login.login_agree')}
                <br />
                <span>{t('general.terms_and_conditions')}</span>
              </p>
            </TermsInfo>
          </Group>
        </Card>
      </LeftSide>
    </Container>
  );
};

export default EnterPhoneNumber;
const Container = styled.div`
  display: flex;
  min-height: 600px;
  height: 100%;
  width: 100%;
  background: ${({ theme }) => theme.menu.background};
`;
const Card = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 600px;
  width: 100%;
  gap: 20px;
  height: 100%;
`;

const CustomPhoneWrapper = styled.div`
  background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
  padding: 0 0 0 16px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  width: 100%;

  input {
    padding: 14px 16px;
    color: ${({ theme }) => theme.menu.primaryTextColor};
    background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
    border-radius: 10px;
    border: none;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    &:focus {
      outline: none;
    }
  }

  .PhoneInputCountry {
    border: none;
    background: ${({ theme }) => theme.chat.selectedBackground};
    border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    align-self: center;
    margin-right: 0;
  }
  .PhoneInput {
    width: 100%;
  }
  .PhoneInputCountrySelectArrow {
    display: none;
  }
  .PhoneInputCountryIcon--border {
    box-shadow: none;
  }
  .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {
    box-shadow: none;
  }
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  h1 {
    color: ${({ theme }) => theme.menu.primaryTextColor};
    font-size: 32px;
    font-weight: 600;
    line-height: 39px;
    letter-spacing: 0px;
    text-align: center;
  }
`;

const LeftSide = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 32px;
  overflow: auto;
`;

const TermsInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    color: ${({ theme }) => theme.menu.secondaryTextColor};
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: center;
  }

  span {
    cursor: pointer;
    color: ${({ theme }) => theme.menu.selectedTextColor};
    font-weight: 600;
    line-height: 22px;
    text-align: center;
    text-decoration: underline;
  }
`;

const Line = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
`;

const InfoText = styled.p`
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
  span {
    color: ${({ theme }) => theme.menu.selectedTextColor};
    cursor: pointer;
  }
`;

const LoginButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`;

const BusinessToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
  overflow: hidden;
  background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
  border: 1px solid ${({ theme }) => theme.toggleButton.borderColor};
`;

const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  border: none;
  background: ${({ theme, selected }) =>
    selected ? theme.primaryButton.background : "none"};
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
  color: ${({ theme, selected }) =>
    selected ? theme.primaryButton.color : theme.menu.secondaryTextColor};
  padding: 12px;
  width: 100%;
  justify-content: center;
  cursor: pointer;
  svg {
    height: 20px;
    fill: transparent;
    fill: color;
  }
`;

const CheckWrapper = styled.div`
  display: flex;
  svg {
    color: ${({ theme }) => theme.check.background};
    fill: ${({ theme }) => theme.check.checkSign};
  }
`;
const CheckEmptyWrapper = styled.div`
  display: flex;
  svg {
    color: ${({ theme }) => theme.check.border};
    stroke: ${({ theme }) => theme.check.checkSign};
  }
`;
